export const EmpresaUtils = {

  pegaReferenciaEmpresa: () => {
    let referencia = window.location.host
    referencia = referencia.replace(/https:\/\//g, '')
    referencia = referencia.replace(/www./g, '')

    if (referencia.includes('localhost')) {
      return 'localhost'
    }

    if (referencia.includes('127.0.0.1')) {
      return '127.0.0.1'
    }

    return referencia
  },

  temAcesso: (acesso, acessosRestritasAcesso) => {
    const acessoRestrita = acessosRestritasAcesso.filter(acessoRestrita => {
      if (acessoRestrita.toLocaleLowerCase() === acesso.toLocaleLowerCase()) {
        return acessoRestrita
      }
    })

    if (acessoRestrita.length > 0) {
      return false
    } else {
      return true
    }
  }
}

export default EmpresaUtils
